import { ITranslationEntry } from '../lang';

export const ID: ITranslationEntry = {
  translations: {
    notifications: 'Notifikasi',
    markAllAsRead: 'Tandai semua sudah dibaca',
    poweredBy: 'Dipersembahkan Oleh',
    settings: 'Pengaturan',
  },
  lang: 'id',
};
